import React from 'react';

import { Trans } from '@lingui/react/macro';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import type { ImageObject } from '../../types';

const useStyles = makeStyles(() => ({
  centerBorderedBox: {
    border: '1px solid gray',
  },
  findingViewerContainer: {
    position: 'relative',
    minHeight: '160px',
    minWidth: '160px',
    '& div': {
      minHeight: '160px',
    },
  },
  hoveredItem: {
    cursor: 'pointer',
    borderColor: 'white',
  },
  imageOverlay: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    zIndex: 10,
    left: '0',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  noImagesMessage: {
    color: 'white',
    fontWeight: 100,
    textAlign: 'center',
  },
  imageBox: {
    width: '10em',
    minHeight: '12em',
  },
}));

interface Props {
  children: React.ReactNode;
  currentImage: ImageObject;
  currentlyHoveredImageId: string;
  currentIndex: number;
  noImagesOnCurrentView: boolean;
  onSetSelectedImage: React.MouseEventHandler<HTMLElement>;
  onSetCurrentlyHoveredImageId: React.Dispatch<React.SetStateAction<string>>;
}

const StripLayoutContainer: React.FC<Props> = ({
  children,
  currentImage,
  currentlyHoveredImageId,
  currentIndex,
  noImagesOnCurrentView,
  onSetSelectedImage,
  onSetCurrentlyHoveredImageId,
}) => {
  const classes = useStyles();

  const getClassNames = () => {
    let className = classes.findingViewerContainer;
    if (currentImage?.objectId === currentlyHoveredImageId) {
      className += ` ${classes.hoveredItem}`;
    }
    return className;
  };

  return (
    <div className={classes.imageBox} key={currentImage.objectId}>
      <Box
        maxHeight={1}
        margin="0"
        onClick={onSetSelectedImage}
        className={getClassNames()}
        onMouseEnter={() => onSetCurrentlyHoveredImageId(currentImage.objectId)}
        onMouseLeave={() => onSetCurrentlyHoveredImageId('')}
      >
        {currentImage.objectId && children}
        {currentImage.objectId && (
          <div className={classes.imageOverlay}  />
        )}
      </Box>

      {noImagesOnCurrentView && currentIndex == 0 && (
        <Box
          position="absolute"
          left="0"
          right="0"
          marginLeft="auto"
          marginRight="auto"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <h3 className={classes.noImagesMessage}>
            <Trans>No radiographs available for selected teeth</Trans>
          </h3>
        </Box>
      )}
    </div>
  );
};

export default StripLayoutContainer;
